// Renovação do token JWT enquanto o usuário usa o sistema. O token vale 96h
// (api/config/jwt.php); quando ele completa 24h de vida, a próxima chamada à
// API renova antes de seguir. Quem fica mais de 96h sem usar cai no 401 e é
// levado ao login pelo axios-catch.
import axios from "axios"

const RENOVAR_APOS_SEGUNDOS = 24 * 60 * 60

// Uma renovação por vez: chamadas simultâneas esperam a mesma promessa.
let renovando = null

function emitidoEm(token) {
    try {
        const payload = token.split(" ").pop().split(".")[1]
        return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/"))).iat || null
    } catch (e) {
        return null
    }
}

function renovar(token) {
    if (!renovando) {
        renovando = axios
            .post(process.env.VUE_APP_API + "/auth/refresh", null, {
                headers: { Accept: "application/json", Authorization: token },
                renovacaoToken: true,
            })
            .then((response) => {
                const { type, token: novo } = response.data.authorization
                const autorizacao = type + " " + novo
                window.localStorage.setItem("token", autorizacao)
                return autorizacao
            })
            .finally(() => {
                renovando = null
            })
    }
    return renovando
}

export function instalarRenovacaoToken() {
    axios.interceptors.request.use(async (config) => {
        if (config.renovacaoToken) return config

        const token = window.localStorage.getItem("token")
        const iat = token && emitidoEm(token)
        if (!iat || Date.now() / 1000 - iat < RENOVAR_APOS_SEGUNDOS) return config

        try {
            const novo = await renovar(token)
            if (config.headers && config.headers.Authorization) config.headers.Authorization = novo
        } catch (e) {
            // Falhou a renovação: segue com o token atual; se ele já expirou,
            // o 401 da própria chamada leva ao login.
        }
        return config
    })
}
